import {
    Affix,
    Avatar,
    Button,
    Card,
    Divider,
    Drawer,
    Input,
    InputRef,
    Menu,
    message,
    Modal,
    Popover,
    Space
} from 'antd';
import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from "react-router-dom";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import {Header} from "antd/es/layout/layout";
import {UserOutlined} from "@ant-design/icons";



const VipRedemption_UI=()=>{

    const inputRef = useRef<InputRef>(null); // antd v5 推荐InputRef 类型


    const navigate=useNavigate();

const data_time=dayjs().unix();
    const Admin_log_out = () => {


        Cookies.remove('userToken_chattool')
        Cookies.remove('group')
        let time = dayjs().unix();
        navigate('/login?return_url=/admin/keyclick')

        return (
            console.log("111")

        );


    }

    const [check_card_info_modal_open, setcheck_card_info_modal_open] = useState(false)

    const [check_card_info_select_info, setcheck_card_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [check_card_info_select_log, setcheck_card_info_select_log] = useState({message: '', value: '', time: 0})
    const check_card_info = (e1: any) => {

        const value = inputRef.current?.input?.value;


        console.log('dd')
        console.log(value+'ddd')
        if(value===''){

            message.error('请输入卡密')

        }else {

            setcheck_card_info_select_log({message: 'click', value: '', time: data_time})



            setcheck_card_info_select_info({value1: String(value), value2: '', value3: '', time: data_time})

            setcheck_card_info_modal_open(true);

        }



    }

    const setcheck_card_info_modal_oncancel = () => {

        setcheck_card_info_modal_open(false);
    }

    const [return_data_check_card_info,setreturn_data_check_card_info]=useState(
    {
        "message": 0,
        "value": "获取成功",
        "info": {
        "tips": "未使用",
            "value": "30天vip",
            "vipday": "30",
            "cardname": "1月vip",
            "card_start_time": 0,
            "card_end_time": 0,
            "card_use": false
    }


    });

    const check_card_info_body = new FormData();


    check_card_info_body.append('key_cdk', check_card_info_select_info.value1);

    check_card_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    check_card_info_body.append('time', String(check_card_info_select_info.time));

    check_card_info_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/vipcard/fetch/check_vipcard.php', {


                method: 'POST',
                body: check_card_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                 /*   message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_check_card_info(return_data);

                    //setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                   /* message.error(return_data.value)*/


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(check_card_info_select_log.message!==''){

            data_async();
            setcheck_card_info_select_log({message:'',value:'',time:0})
        }
    }, [check_card_info_select_log]);





    const [VipRedemption_check_card_select_info, setVipRedemption_check_card_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [VipRedemption_check_card_select_log, setVipRedemption_check_card_select_log] = useState({message: '', value: '', time: 0})
    const VipRedemption_check_card = (e1: any) => {
        const value = inputRef.current?.input?.value;

        if(value===''){

            message.error('请输入卡密')

        }else {

            setVipRedemption_check_card_select_log({message: 'click', value: '', time: data_time})


            setVipRedemption_check_card_select_info({value1: String(value), value2: '', value3: '', time: data_time})


        }
    }


    const [return_data_VipRedemption_check_card,setreturn_data_VipRedemption_check_card]=useState({});

    const VipRedemption_check_card_body = new FormData();


    VipRedemption_check_card_body.append('key_cdk', VipRedemption_check_card_select_info.value1);

    VipRedemption_check_card_body.append('userToken', String(Cookies.get('userToken_chattool')));

    VipRedemption_check_card_body.append('time', String(VipRedemption_check_card_select_info.time));

    VipRedemption_check_card_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/vipcard/fetch/check_vipcard.php', {


                method: 'POST',
                body: VipRedemption_check_card_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:



                    if(!return_data.info.card_use){


                        const value = inputRef.current?.input?.value;
                        /*    message.success(return_data.value)*/
                        let data_time = dayjs().unix();
                        setVipRedemption_select_log({message: 'click', value: '', time: data_time})

                        setVipRedemption_modal_open(true);

                        setVipRedemption_select_info({value1: String(value), value2: '', value3: '', time: data_time})

                    }else{


                        message.error(return_data.value)
                    }
                    setreturn_data_VipRedemption_check_card(return_data);

                   // setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(VipRedemption_check_card_select_log.message!==''){

            data_async();
            setVipRedemption_check_card_select_log({message:'',value:'',time:0})
        }
    }, [VipRedemption_check_card_select_log]);




    const [VipRedemption_modal_open, setVipRedemption_modal_open] = useState(false)

    const [VipRedemption_select_info, setVipRedemption_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [VipRedemption_select_log, setVipRedemption_select_log] = useState({message: '', value: '', time: 0})
    const VipRedemption = (e1: any) => {


        const value = inputRef.current?.input?.value;

        if(value===''){

            message.error('请输入卡密')

        }else{

            setVipRedemption_select_log({message: 'click', value: '', time: data_time})

            setVipRedemption_modal_open(true);

            setVipRedemption_select_info({value1: String(value), value2: '', value3: '', time: data_time})
        }


    }


    const setVipRedemption_modal_oncancel = () => {

        setVipRedemption_modal_open(false);
    }


    const [VipRedemption_modal_next_button_select_log,setVipRedemption_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const VipRedemption_modal_next_button = () => {

        let data_time=dayjs().unix();

        setVipRedemption_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_VipRedemption,setreturn_data_VipRedemption]=useState({});

    const VipRedemption_body = new FormData();


    VipRedemption_body.append('key_cdk', VipRedemption_select_info.value1);

    VipRedemption_body.append('userToken', String(Cookies.get('userToken_chattool')));

    VipRedemption_body.append('time', String(VipRedemption_modal_next_button_select_log.time));

    VipRedemption_body.append('action', 'use');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/vipcard/use/use_vipcard.php', {


                method: 'POST',
                body: VipRedemption_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                   message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setVipRedemption_modal_open(false)

                    setreturn_data_VipRedemption(return_data);
                 //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)
                    setVipRedemption_modal_open(false)

                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

            }

        }


        if(VipRedemption_modal_next_button_select_log.message!==''){

            data_async();
            setVipRedemption_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [VipRedemption_modal_next_button_select_log]);





    return (
        <div style={{display:'flex',flexDirection:'column',padding:'20px'}}>
            <Affix offsetTop={0}>
                <Header style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    background: "#FFFFFF",
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    zIndex: 1000, // Ensure Header is on top

                }}>

                    <h3 style={{color: "#000000", margin: 0}}>后台管理</h3>

                    <div style={{textAlign: 'right'}}>

                        <Popover arrow={false} placement="topRight" content={<div style={{}}>

                            <Menu>

                                <Menu.Item key="0">
                                    <label  onClick={()=>(window.open('/userinfo'))}>
                                        个人中心
                                    </label>
                                </Menu.Item>
                                <Menu.Item key="1">
                                    <label   onClick={Admin_log_out}>
                                        退出登录
                                    </label>
                                </Menu.Item>
                            </Menu>

                        </div>} title="Title">
                            <Avatar size={32} icon={<UserOutlined />} />
                        </Popover>

                    </div>

                </Header>

            </Affix>



            <div style={{height:60}}>


            </div>


            <div style={{display:'flex',alignContent:'center',justifyContent:'center',width:'100%',minWidth:1080,overflowY:'auto'}}>




            <Card style={{width:900}}>




<label>会员兑换</label>





            <Input ref={inputRef} style={{marginTop:20}} onPressEnter={VipRedemption_check_card} placeholder="请输入会员卡密">


            </Input>



            <Space style={{marginTop:20}}>
                <Button type={'primary'} onClick={VipRedemption_check_card}>兑换</Button>

                <Button onClick={check_card_info}>查询时长</Button>


            </Space>



            </Card>


            </div>

            <Modal open={check_card_info_modal_open} onCancel={setcheck_card_info_modal_oncancel} footer={null} title={'会员卡信'}>

                {return_data_check_card_info.message!==2000?<></>:<div>{return_data_check_card_info.info.card_use?<div>{return_data_check_card_info.info.tips}</div>:<div style={{display:'flex',flexDirection:'column'}}>


                    <label>面值：{return_data_check_card_info.info.cardname}</label>
                <label>卡片有效期：{dayjs.unix(return_data_check_card_info.info.card_end_time).format('YYYY-MM-DD HH:mm:ss')}</label>

                </div>}</div>}


              {/*  <Button style={{marginLeft:10}} onClick={setcheck_card_info_modal_oncancel}>

                    取消
                </Button>
*/}

            </Modal>




            <Modal open={VipRedemption_modal_open} onCancel={setVipRedemption_modal_oncancel} footer={null} title={'是否确认兑换？'}>


                <Button type={'primary'} onClick={VipRedemption_modal_next_button}>

                    确认兑换
                </Button>


                <Button style={{marginLeft:10}} onClick={setVipRedemption_modal_oncancel}>

                    取消
                </Button>


            </Modal>



        </div>
    )



}
export default VipRedemption_UI;